<template src="./InputPasswordNormal.html"></template>

<script>
import IconEyeSlash from '@/components/icons/IconEyeSlash.vue'
import IconEye from '@/components/icons/IconEye.vue'

export default {
  name: 'InputPasswordNormal',
  components: { IconEye, IconEyeSlash },
  props: {
    disabled: {
      type: Boolean,
      required: false,
      default: () => false
    },
    id: {
      type: String,
      required: true
    },
    label: {
      type: String,
      required: false,
      default: () => ''
    },
    valueDefault: {
      type: String,
      required: false,
      default: () => ''
    },
    errorText: {
      type: String,
      required: false,
      default: () => ''
    },
    isError: {
      type: Boolean,
      required: false,
      default: () => false
    },
  },
  created() {
    if (this.valueDefault) {
      this.value = this.valueDefault
    }
  },
  data() {
    return {
      value: '',
      type: 'password',
      isShow: false,
      distanceWithLabel: '0px',
    }
  },
  watch: {
    value() {
      this.$emit('inputValue', this.value)
    },
    valueDefault() {
      this.value = this.valueDefault
    },
    errorText() {
      this.distanceWithLabel = (this.$refs.labelForm?.offsetWidth || 0) + 10 + 'px'
    }
  },
  methods: {
    showPassword() {
      this.isShow = !this.isShow
      this.type = 'password'
      if (this.isShow) {
        this.type = 'text'
      }
    }
  }
}
</script>

<style scoped lang="scss">
  .input-password {
    .show-hide {
      width: 15px;
      position: absolute;
      cursor: pointer;
      top: 70%;
      right: 20px;
      transform: translateY(-50%);
    }
    .top-error {
      top: 70%;
    }
  }
  .error-text {
    color: red;
    margin: 0;
  }
  .is-error {
    border: 1px solid red;
  }
</style>
